import { useState, useEffect, useRef, useCallback } from "react"
import { apim } from "@/constants/api"
import {
  debounce,
  findStoreBuildQuery,
  findStoreBuildQueryFromUrl,
  getFacetsFromUrl,
  getMyLocation,
  storeFilterData,
  isShowAnalyticsEventLoaded,
  navigationType,
  sanitizeText,
} from "@/utils/helper"
import _get from "lodash/get"
import _isEmpty from "lodash/isEmpty"
import { getConfig } from "@/constants/config"
import { aemAxiosInstance } from "@/constants/api"
import { useDispatch, useSelector } from "react-redux"
import {
  BOOLEAN_VALUE_RESPONSE,
  GLOBAL_CONFIGURATION_ENDPOINT,
} from "@/constants/index"
import FindShowroomLanding from "./FindShowroomLanding"
import useFindashowroomi18n from "@/i18n/useFindashowroomi18n"
import blackMarker from "@/public/icons/locator-big-chacrol.svg"
import redMarker from "@/public/icons/locator-big-red.svg"
import greenMarker from "@/public/icons/locator-big-green.svg"
import {
  setMyStore,
  locationState,
  setStoreAddress,
} from "@/store/features/locationSlice"
import { getStoreDataById } from "@/utils/location"

const FindShowroom = props => {
  const { data } = props
  const {
    findStoreItemsTab1,
    findStoreItemsTab2,
    findStoreItemsTab3,
    inactiveTab1 = false,
    inactiveTab2 = false,
    inactiveTab3 = false,
    mapPinIconTab1 = "",
    mapPinIconTab2 = "",
    mapPinIconTab3 = "",
    tabTitleTab1 = "",
    tabTitleTab2 = "",
    tabTitleTab3 = "",
    noResultMessage = "",
  } = data
  const onceRef = useRef()
  const dispatch = useDispatch()
  const { myStoreId, browseLocationsStoreFilterData } =
    useSelector(locationState)
  const [tabList, setTabList] = useState([])
  const [findStoreDetails, setFindStoreDetails] = useState("")
  const [findStores, setFindStores] = useState("")
  const [findaStoreQuery, setFindaStoreQuery] = useState("")
  const [siteName, setSiteName] = useState("")
  const [searchTerm, setSearchTerm] = useState("")
  const [findStoresBingKey, setFindStoresBingKey] = useState("")
  const [infoModal, setInfoModal] = useState(false)
  const [infoModalError, setinfoModalError] = useState({})
  const [info, setInfo] = useState({})
  const [curFilters, setCurFilters] = useState([])
  const [citySuggestData, setCitySuggestData] = useState([])
  const [latitude, setLatitude] = useState(0)
  const [longitude, setLongitude] = useState(0)
  const [responseData, setResponseData] = useState([])
  const [curFilterQueries] = useState([])
  const [distanceInMiles] = useState(161)
  const [activeTab, setActiveTab] = useState(0)
  const [findStoreCheckedId, setFindStoreCheckedId] = useState("")
  const [findStoreFilterData] = useState(
    _get(browseLocationsStoreFilterData, "storefilter", {})
  )

  useEffect(() => {
    setFindStoreCheckedId(localStorage.getItem("myStoreId") ?? 0)
  }, [])
  const fetchZipCodeFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search)
    const urlZipCode = urlParams.get("q")
    setSearchTerm(urlZipCode ? urlZipCode : "")
  }

  const getGeoLocation = type => {
    getMyLocation()
      .then(getLocation => {
        setSearchTerm(getLocation?.zipcode ?? "")
      })
      .catch(error => {
        addFindAStoreAnalytics({
          status: "failure",
          total: 0,
          errorMessage:
            staticTexts?.messageZipcode?.toLowerCase() || error?.message,
          type,
        })
        setinfoModalError("")
        setInfoModal(true)
      })
  }
  const handleChange = inputVal => {
    setSearchTerm(inputVal)
    localStorage.setItem("searchTerm", inputVal)
  }

  useEffect(() => {
    if (myStoreId !== findStoreCheckedId) {
      localStorage.setItem("myStoreId", myStoreId)
      setFindStoreCheckedId(myStoreId)
    }
  }, [myStoreId])
  useEffect(() => {
    if (myStoreId !== 0 && !_isEmpty(info)) {
      getUtilityDataById()
    }
  }, [myStoreId, info])

  const getUtilityDataById = async () => {
    const utilityData = await getStoreDataById({
      myStoreId: myStoreId,
      findStores: findStores,
      siteName: info.siteName,
    })
    dispatch(setStoreAddress(utilityData))
  }

  const handleFindStoreCheck = entity => {
    localStorage.setItem("myStoreId", entity)
    dispatch(setMyStore(entity))
    setFindStoreCheckedId(entity)
  }

  const addFindAStoreAnalytics = params => {
    const { total, errorMessage, status, type = null, searchItem = null } = params
    let errMsg = sanitizeText(
      staticTexts?.locationErrormessage
        ? staticTexts?.locationErrormessage?.toLowerCase()
        : this.props.t("kf.findstore.label.locationErrormessage")
    )?.replace("\n", "")
    if (total == 0)
      errMsg = sanitizeText(`${noResultMessage}`)?.replace("\n", "")
    const pageObj = window?.adobeDataLayer?.[0]?.page
    const event = !isShowAnalyticsEventLoaded() ? "cmp:show" : "cmp:click"
    const pageComponent =
      event === "cmp:show" ? pageObj?.category?.subCategoryID : "find a store"
    const storeSearchType = pageComponent?.split(" ")?.[2]
    const currDate = new Date()
    const eventInfo = {
      searchCount: sessionStorage.getItem("findStores")
        ? Number(sessionStorage.getItem("findStores")) + 1
        : 1,
      searchResult: total,
      internalLinkName:
        (type && type.length > 0 && type?.toLowerCase()) ||
        `${storeSearchType} search`,
      internalLinkPosition: `${pageComponent}`,
      internalLinkType: `${pageComponent}:navigation`,
      searchType: isNaN(searchTerm) ? "Location" : "ZipCode",
      searchTerm: searchItem || searchTerm,
      eventAction: `${pageComponent}:landing:location info​:${storeSearchType} search`,
      eventName: `${pageComponent}:landing:location info​:${storeSearchType} search`,
      eventType: "navigation",
      clickInternalLinks: "true",
      internalLinkURL: window.location.origin + window.location.pathname,
      internalLinkZoneName: `${pageComponent}:landing:location info`,
      eventMsg: status === "success" ? "n/a" : errorMessage || errMsg || "n/a",
      eventStatus: status === "success" ? "success" : "failure",
      pageName: `${pageComponent} result`,
      pageURL: window.location.href,
      referrer: document.referrer || "n/a",
      previousPage: document.referrer || "n/a", // we can not get previous page name
      timeStamp:
        currDate.toISOString().split("T")[0] +
        " " +
        currDate.toTimeString().split(" ")[0],
    }
    if (
      (event === "cmp:show" && !isShowAnalyticsEventLoaded()) ||
      event !== "cmp:show"
    ) {
      sessionStorage.setItem("findStores", eventInfo.searchCount)
      const dtLayerObj = {
        event,
        page: pageObj,
      }

      if (
        (navigationType() !== 1 && event === "cmp:show") ||
        event === "cmp:click"
      ) {
        dtLayerObj.eventInfo = eventInfo
      }

      window.adobeDataLayer.push({ ...dtLayerObj })
      delete window.pageObj
    }
  }

  const {
    all,
    annSacks,
    annSacksText,
    annsacksShowroom,
    annsacksShowroomImgAlt,
    applyFilters,
    ariaLabel,
    away,
    backToTop,
    browseAllStore,
    clearAll,
    countryPlaceholder,
    ctaLabel,
    ctaLink,
    filterImgAlt,
    filters,
    findStore,
    genuinePartsDealers,
    home,
    homeCenter,
    isNewTab,
    items,
    kohler,
    kohlerStore,
    kohlerStoreImgAlt,
    kohlerStores,
    loadMore,
    locationErrormessage,
    miles,
    mostPopular,
    myStore,
    partsDealer,
    readArticleText,
    results,
    retailMobileText,
    retailStore,
    setAsMyShowroom,
    setAsMyStore,
    showrooms,
    storeDetail,
    userMyLocation,
    view,
    viewList,
    viewMap,
    viewResults,
    viewShowroomDetails,
    viewStoreDetail,
    expanded,
    collapsed,
    filterTitle,
    MessageZipcode: messageZipcode,
    messageTitleZipcode: infoModalTitle,
    continue: continue_,
    filterSort,
  } = useFindashowroomi18n(data)
  const staticTexts = {
    all,
    annSacks,
    annSacksText,
    annsacksShowroom,
    annsacksShowroomImgAlt,
    applyFilters,
    ariaLabel,
    away,
    backToTop,
    browseAllStore,
    clearAll,
    countryPlaceholder,
    ctaLabel,
    ctaLink,
    filterImgAlt,
    filters,
    findStore,
    genuinePartsDealers,
    home,
    homeCenter,
    isNewTab,
    items,
    kohler,
    kohlerStore,
    kohlerStoreImgAlt,
    kohlerStores,
    loadMore,
    locationErrormessage,
    miles,
    mostPopular,
    myStore,
    partsDealer,
    readArticleText,
    results,
    retailMobileText,
    retailStore,
    setAsMyShowroom,
    setAsMyStore,
    showrooms,
    storeDetail,
    userMyLocation,
    view,
    viewList,
    viewMap,
    viewResults,
    viewShowroomDetails,
    viewStoreDetail,
    expanded,
    collapsed,
    filterTitle,
    messageZipcode,
    infoModalTitle,
    continue_,
    filterSort,
  }
  useEffect(() => {
    getConfig().then(async config => {
      const locale = _get(config, "internationalization.locale", "")
      const currencySign = _get(config, "internationalization.currencySign", "")
      const currencyCode = _get(config, "internationalization.currencyCode", "")
      const findStoreDetailsUrl = _get(
        config,
        "general.storeDetailsServletPath",
        ""
      )
      const reverseGeo = _get(config, "apiEndPointData.reverseGeo", "")
      const findStoresBingKey_ = _get(
        config,
        "apiEndPointData.findStoresBingKey",
        ""
      )
      setFindStoresBingKey(findStoresBingKey_)
      const siteName = _get(config, "general.siteName", "")
      setFindaStoreQuery(_get(config, "general.findaStorequery", ""))
      const findStores_ = _get(config, "apiEndPointData.findStores", "")
      setFindStores(findStores_)
      setSiteName(siteName)
      const info = {
        locale: locale,
        currencySign: currencySign,
        currencyCode: currencyCode,
        findStores: findStores_,
        reverseGeo: reverseGeo,
        findStoresBingKey: findStoresBingKey,
        siteName: siteName,
        findStoreDetailsUrl,
      }
      setInfo(info)
      aemAxiosInstance({
        url: GLOBAL_CONFIGURATION_ENDPOINT,
        params: {
          path: findStoreDetailsUrl,
        },
      })
        .then(response => {
          if (response && response.data) {
            setFindStoreDetails(response.data)
          }
        })
        .catch(err => {
          console.log("Failed to get compare attributes JSON file", err)
        })
    })
    fetchZipCodeFromUrl()
    changeTab(0)
  }, [findStores])
  useEffect(() => {
    const tabList_ = [
      {
        tabDetail: "tabDetail1",
        title: tabTitleTab1,
        qryDetail: findStoreItemsTab1,
        key: kohlerStore,
        id: 0,
        icon: mapPinIconTab1 ?? blackMarker,
        locationNote: tabTitleTab1,
        locationNoteMobile: kohler,
        inActive: inactiveTab1 ?? false,
      },
      {
        tabDetail: "tabDetail2",
        title: tabTitleTab2,
        qryDetail: findStoreItemsTab2,
        key: showrooms,
        id: 1,
        icon: mapPinIconTab2 ?? redMarker,
        locationNote: tabTitleTab2,
        locationNoteMobile: showrooms,
        inActive: inactiveTab2 ?? false,
      },
      {
        tabDetail: "tabDetail3",
        title: tabTitleTab3,
        qryDetail: findStoreItemsTab3,
        key: genuinePartsDealers,
        id: 2,
        icon: mapPinIconTab3 ?? greenMarker,
        locationNote: tabTitleTab3,
        locationNoteMobile: genuinePartsDealers,
        inActive: inactiveTab3 ?? false,
      },
    ]
    setTabList(tabList_)
  }, [])

  const setUrlParam = keyword => {
    if (keyword) {
      const url = new URL(window.location.href)
      let searchParams = url.searchParams
      searchParams.set("q", keyword)
      const urlSearch = "?" + searchParams.toString()
      window.history.replaceState(
        window.location.pathname,
        document.title,
        urlSearch
      )
    }
  }

  const changeTab = tab => {
    setActiveTab(tab)
  }
  const callOnceNoRenderOnTabChange = cb => {
    if (cb && onceRef.current) {
      onceRef.current = null
      cb([], distanceInMiles, true, false, [])
    }
  }

  const finalIndividualQueries = []
  finalIndividualQueries.push(
    ...findStoreBuildQuery([
      findStoreItemsTab1,
      findStoreItemsTab2,
      findStoreItemsTab3,
    ])
  )

  useEffect(() => {
    const urlFilters = getFacetsFromUrl()

    let urlQueryFilters = []
    if (urlFilters.length > 0) {
      urlQueryFilters = [
        ...urlFilters.filter(urlFilter => urlFilter.facet !== "q"),
      ]
      if (urlQueryFilters.length > 0) {
        Object.assign(urlQueryFilters[0], {
          query: [...urlQueryFilters[0]?.value],
        })
      }
    }
    setCurFilters(urlQueryFilters)
  }, [])

  const filterSelect = (tabs, selectQuery, searchTerm, curFilters = []) => {
    const activeTabs = tabs.filter(tab => !tab.inActive)
    const api = index =>
      apim.get(findStores, {
        params: {
          $format: "json",
          brand: siteName.toLowerCase(),
          spatialFilter: `nearby('${searchTerm}',${distanceInMiles})`,
          $select: selectQuery,
          $filter:
            findStoreBuildQueryFromUrl(curFilters, BOOLEAN_VALUE_RESPONSE) +
            finalIndividualQueries[index],
        },
      })
    return Promise.allSettled(activeTabs.map(aT => api(aT.id)))
  }
  const func = (
    curFilters = [],
    preventUnwantedDataLayer = false,
    searchTerm,
    isAutoComplete,
    type
  ) => {
    setResponseData([])
    if (findStores) {
      if (searchTerm.length > 2) {
        filterSelect(tabList, findaStoreQuery, searchTerm, curFilters)
          .then(responses => {
            let totalResults = 0
            responses &&
              responses?.map((response, idx) => {
                if (
                  response.status === "fulfilled" &&
                  response.value &&
                  response.value.data
                ) {
                  setResponseData(prevState => {
                    if (response.value.data.d.results.length > 0) {
                      return [
                        ...prevState,
                        { [idx]: response.value.data.d.results },
                      ]
                    } else return prevState
                  })
                  setLatitude(
                    response.value.data.d.results.length > 0
                      ? response.value.data.d.results[idx]?.Latitude
                      : 0
                  )
                  setLongitude(
                    response.value.data.d.results.length > 0
                      ? response.value.data.d.results[idx]?.Longitude
                      : 0
                  )
                  setUrlParam(searchTerm)
                }
                if (
                  response.status === "fulfilled" &&
                  response.value &&
                  response.value.data
                ) {
                  const results = response.value.data.d.results.map(
                    city => city.Locality
                  )
                  setCitySuggestData([...new Set(results)] ?? [])
                }
                totalResults += response?.value?.data.d.results.length || 0
              })
            if (!preventUnwantedDataLayer) {
              if (!isNaN(searchTerm)) {
                addFindAStoreAnalytics({
                  status: "success",
                  total: totalResults,
                  type,
                  searchItem: searchTerm,
                })
              } else {
                addFindAStoreAnalytics({
                  status: "success",
                  total: totalResults,
                  type,
                  searchItem: searchTerm,
                })
              }
            }
          })
          .catch(err => {
            console.error("Error occured while fetching Search data", err)
          })
      } else {
        if (!preventUnwantedDataLayer) {
          addFindAStoreAnalytics({
            status: type ? "failure" : "n/a",
            total: 0,
            type,
            searchItem: searchTerm,
          })
        }
        setResponseData([])
        setLatitude([])
        setLongitude([])
        setCitySuggestData([])
      }
    }
  }

  const getStoreDetails = useCallback(debounce(func, 2000), [tabList,findStores])
  useEffect(() => {
    getStoreDetails(curFilters, false, searchTerm)
    callOnceNoRenderOnTabChange(debounce(func, 3000))
  }, [searchTerm])
  let facets = {}
  if (findStoreFilterData) {
    facets = storeFilterData(findStoreFilterData)
  }
  return (
    <>
      <h1 className="sr-only">Find a Showroom</h1>
      {tabList.length > 0 && (
        <FindShowroomLanding
          infoModalError={infoModalError}
          infoModal={infoModal}
          InfoModal={() => setInfoModal(false)}
          responseData={responseData}
          staticTexts={staticTexts}
          tabList={tabList}
          activeTab={activeTab}
          findStoresBingKey={findStoresBingKey}
          latitude={latitude}
          longitude={longitude}
          getStoreDetails={(curFilters, preventUnwantedDataLayer) =>
            getStoreDetails(curFilters, preventUnwantedDataLayer, searchTerm)
          }
          handleChange={handleChange}
          searchTerm={searchTerm}
          citySuggestData={citySuggestData}
          changeTab={changeTab}
          findStoreDetails={findStoreDetails}
          handleFindStoreCheck={(entity) =>
            handleFindStoreCheck(entity)
          }
          findStoreCheckedId={findStoreCheckedId}
          facets={facets}
          getGeoLocation={type => getGeoLocation(type)}
          selectedFilterCount={
            responseData
              ? responseData?.length > 0 &&
                responseData
                  .map(b => Object.values(b).flat().length)
                  .reduce((item, acc) => acc + item, 0)
              : curFilterQueries &&
                curFilterQueries.reduce((acc, item) => {
                  return acc + item.value.length
                }, 0)
          }
          totalResults={data && data.length}
        />
      )}
    </>
  )
}

export default FindShowroom
